import React, { useCallback, useState } from "react";
import { LoadingButton } from "../../components/LoadingButton";
import { adminApi, extractErrorMessage } from "../../util/api";

const successCallback = (ref) => {
  const { setMessage } = ref.current;
  return setMessage(`Queued seeqer case results CSV job successfully`, "success");
};

const errorCallback = (ref, err) => {
  const { setMessage } = ref.current;
  return setMessage(extractErrorMessage(err), "danger");
};

export const RunSeeqerCaseResultsButton = React.forwardRef(({ resourceId, label = "Run seeqer case results", ...rest }, ref) => {
  const [loading, setLoading] = useState(false);

  const getUrl = useCallback(() => {
    return `/admin/clinics/${resourceId}/run_seeqer_case_results`;
  }, [resourceId]);

  const handleClick = async () => {
    setLoading(true);
    try {
      await adminApi.post(getUrl());
      if (ref) successCallback(ref);
    } catch (err) {
      if (ref) errorCallback(ref, err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingButton onClick={handleClick} loading={loading} {...rest}>
      {label}
    </LoadingButton>
  );
});
